import React, { useEffect } from 'react';
import {
  Box,
  Text,
} from '@chakra-ui/react';
import { useFormContext, useWatch } from 'react-hook-form';
import FormInput from '../FormInput';
import FormCheckbox from '../FormCheckbox';
import AccountTypeSelector from '../AccountTypeSelector';
import useUnitData from '../../hooks/UseUnitData';
import { sizes } from '../../theme';

const ACHInformation = () => {
  const { saveCreditCard, enrollAutoPay } = useWatch();
  const { setValue } = useFormContext();

  const { data: {
    facility: { autoPayRequired, seAchTypes },
  } } = useUnitData();
  useEffect(() => {
    if (autoPayRequired) {
      setValue('saveCreditCard', true);
      setValue('enrollAutoPay', true);
    }
  }, [autoPayRequired, setValue]);

  useEffect(() => {
    if (saveCreditCard) { return; }
    setValue('enrollAutoPay', false);
  }, [saveCreditCard, enrollAutoPay]);
  const accountTypeOptions = Object.entries(seAchTypes ?? {}).map(([description, id]) => ({
    id,
    description,
  }));

  return (
    <Box w="100%">
      <Text fontSize="md" fontWeight="bold" mb={sizes._4px}>
        Enter Your Payment Details
      </Text>

      <FormInput name="achFirstName" label="First name" />
      <FormInput name="achLastName" label="Last name" />
      <FormInput name="achBankName" label="Bank name" />

      <Box>
        <AccountTypeSelector name="achAccountType" options={accountTypeOptions} />
      </Box>

      <FormInput name="achAccountNumber" label="Account Number" inputMode="numeric" allowOnlyNumbers />
      <FormInput name="achRoutingNumber" label="Routing Number" inputMode="numeric" allowOnlyNumbers />

      <Box paddingTop={sizes._8px} marginBottom={sizes._16px}>
      {autoPayRequired
        ? (
      <Text variant="sm" color="gray.dark" marginBottom={sizes._4px}>
          The cardholder/account holder authorizes to charge any amounts due per the
            terms of the agreement for each period during the term of occupancy or until
            the cardholder/account holder cancels this authorization.
      </Text>
        )
        : (
      <>
        <FormCheckbox
          name="saveCreditCard"
          label="Save card on file for future payments"
          marginBottom={sizes._24px}
        />
        <FormCheckbox
          name="enrollAutoPay"
          label="Enroll in auto pay"
          tooltip="Auto pay is a free service that automatically deducts payments from your bank account each month."
          isDisabled={!saveCreditCard}
          isChecked={enrollAutoPay}
        />
      </>
        )}
      </Box>
    </Box>
  );
};

export default ACHInformation;
